import { getCollection, createCollection, COLLECTIONS } from 'state/snapi/slice';

// Load Memberships
export const loadProgramMemberships = (params, options = {}) => dispatch =>
  dispatch(getCollection(COLLECTIONS.PROGRAM_MEMBERSHIPS, 'program_memberships/search', params, options));

export const createNewProgramMembership = params => dispatch =>
  dispatch(createCollection(COLLECTIONS.PROGRAM_MEMBERSHIPS, 'program_memberships', params));
